import { useCallback } from 'react';
import { useField } from 'formik';
import {
  blockNegativeNumberInputKeys,
  clampNonNegativeNumberInputValue,
} from '../utils/lifecarePlanUtils';

// wires a Formik field to the shared XInput/XTextarea primitives so the
// component layer stays presentational. For numeric fields we also (a) intercept
// onChange to clamp negatives and (b) swallow the "-", "+", "e", "E" keystrokes —
// `<input min={0}>` is only spinner-button enforced in browsers, so users can
// otherwise still type "-5" or "--" without these guards.
const useLifecareStudioField = ({ name, placeholder, className, type }) => {
  const [field] = useField(name);
  const isNumeric = type === 'number';

  const onChange = useCallback(
    (event) => {
      if (!isNumeric) {
        field.onChange(event);
        return;
      }
      const sanitized = clampNonNegativeNumberInputValue(event.target.value);
      if (sanitized === event.target.value) {
        field.onChange(event);
        return;
      }
      field.onChange({ ...event, target: { ...event.target, name, value: sanitized } });
    },
    [field, isNumeric, name]
  );

  const extraProps = isNumeric ? { onKeyDown: blockNegativeNumberInputKeys } : {};
  return { ...field, onChange, placeholder, className, ...extraProps };
};

export default useLifecareStudioField;
